import hookSiteSelectedFactory from "@/stores/base-factories/store-site-selection";
import createStore from "@Stores/base-factories";

import { hookGlobalCustomFieldsFactory } from "./customFields";
import { hookGlobalSiteSettingFactory } from "./factory";
import { hookGlobalMetaFieldsFactory } from "./meta-fields";
import { hookGlobalAppVersionFactory } from "./version";

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extend(hookGlobalSiteSettingFactory('cms/setting'))
  .extend(hookGlobalAppVersionFactory())
  .extend(hookGlobalCustomFieldsFactory())
  .extend(hookGlobalMetaFieldsFactory())
  .factory()

export {
  Provider as GlobalProvider,
  useStore as useGlobalStore,
}
